import React, { useEffect, useState } from 'react'
import { FaFutbol, FaCopy, FaClock, FaFileSignature } from "react-icons/fa";
import { LoadingSpinner } from "../../components";
import goalResultService from "../../services/goalResultService";
import moment from 'moment/moment';
//import expendArrow from '../../assets/icons/Expand Arrow.png';
import { setToastMessage } from '../../reducers/common.reducer';
import { useDispatch } from 'react-redux';
import Badge from '@mui/material/Badge';
import ArticleIcon from '@mui/icons-material/Article';
import { useWindowWidth } from '@react-hook/window-size';
import {Tooltip} from '@mui/material';
import CustomCalendarSVG from '../../components/CustomCalendarSVG';
import { FaAngleDown } from "react-icons/fa";
import CustomSearchBtn from '../../components/CustomSearchBtn';
import CustomNoData from '../../components/CustomNoData';
import ConfirmationDialog from '../../components/ConfirmationDialog';

const title = ["Goal Result"];

const filterType = [
    { "value": "all", "label": "All Events" },
    { "value": "notEnded", "label": "Not Ended" },
    { "value": "voucher", "label": "Has Vouchers" }
]

const InsertResult = (props) => {
    const { activeTitle, apis } = props;
    const dispatch = useDispatch();
    const onlyWidth = useWindowWidth();
    const [goalResultList, setGoalResultList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [date, setDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
    const [selectedFilter, setSelectedFilter] = useState(filterType[1]);
    const [showResultList, setShowResultList] = useState([]);
    const [mixCount, setMixCount] = useState(0);
    const [calculateTarget, setCalculateTarget] = useState(null);

    useEffect(() => {
        getAllGoalResult();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTitle])

    const handleSearch = async () => {
        try {
            getAllGoalResult();
        }
        catch (error) {
            console.log({ error });
        } finally {

        }
    }

    const getAllGoalResult = async () => {
        try {
            setIsLoading(true);
            const payload = {
                selectedDate: date
            }
            const goalResultList = await goalResultService.getResultWithVouchers(apis.getApi, payload);

            if (goalResultList.data.status !== 403) {
                const formattedValue = goalResultList.data.payload.sort((a, b) => a.event - b.event);
                setGoalResultList(formattedValue);
                setMixCount(goalResultList.data.mixCount);
                setShowResultList(formattedValue.filter(a => a.homeGoal === "NE" && a.awayGoal === "NE"));
                setSelectedFilter(filterType[1]);
            }

        } catch (error) {
            console.log({ error });
        } finally {
            setIsLoading(false);
        }
    }

    const handleChange = async (id, result, type) => {
        setShowResultList((prev) =>
            prev.map((item) =>
                item.eventId === id ? { ...item, [type]: result } : item
            )
        );
    }

    const handleSave = async () => {
        try {
            setIsLoading(true);
            let payload = [];

            const filteredInfo = showResultList.filter(a => a.homeGoal !== "NE" && a.awayGoal !== "NE");

            if (filteredInfo.length === 0) {
                dispatch(setToastMessage({ type: "error", message: "Please fill result !!!" }));
                return;
            }

            filteredInfo.forEach(element => {
                const { homeGoal, awayGoal, eventId, upcommingId } = element;
                const obj = {
                    homeResult: Number(homeGoal),
                    awayResult: Number(awayGoal),
                    eventId: Number(eventId),
                    preId: Number(upcommingId)
                }

                payload.push(obj);
            });
        
            const response = await goalResultService.addGoalMultiple(apis.insertMultipleApi, payload);

            if (response.status !== 403) {
                dispatch(setToastMessage({ type: "success", message: response.data.message }));
                getAllGoalResult();
            }
        }
        catch (error) {
            console.log({ error });
        }
        finally {
            setIsLoading(false);
        }
    }

    const handleSelect = (v) => {
        setSelectedFilter(v);
        let value = v.value;
        let filteredData;

        switch (value) {
            case 'all':
                setShowResultList(goalResultList);
                break;
            case 'notEnded':
                filteredData = goalResultList.filter(a => a.homeGoal === "NE" && a.awayGoal === "NE");
                setShowResultList(filteredData);
                break;
            case 'voucher':
                filteredData = goalResultList.filter(a => a.activeVoucherCount > 0);
                setShowResultList(filteredData);
                break;
            default:
                filteredData = [];
                break;
        }
    }

    const handleCopy = (v) => {
        navigator.clipboard.writeText(`${v.league} ${v.homeTeam} VS ${v.awayTeam}`);
    }

    const handleCalculateClick = (v) => {
        setCalculateTarget(v);
    }

    const handleCalculate = async () => {
        try {
            setIsLoading(true);
            const v = calculateTarget;
            if (!v) return;

            const { homeGoal, awayGoal, eventId, activeVoucherCount } = v;
            
            if(activeVoucherCount === 0){
                dispatch(setToastMessage({ type: "success", message: "No pending vouchers!!" }));
                return; 
            }

            const payload = {
                homeResult: homeGoal,
                awayResult: awayGoal,
                eventId: Number(eventId),
                isPostPoned: homeGoal === "-2" && awayGoal === "-2" ? true : false
            }
            const response = await goalResultService.calculateVouchers(apis.calculateApi, payload);

            if (response.status !== 403) {
                dispatch(setToastMessage({ type: "success", message: response.data.message }));
            }
        }
        catch (error) {
            console.log({ error });
        } finally {
            setCalculateTarget(null);
            setIsLoading(false);
        }
    }

    // const handlePostPoned = async(id,value) => {
    //     console.log("final payload", showResultList);
    //     if(value === true){
    //         setShowResultList((prev) =>
    //             prev.map((item) =>
    //                 item.eventId === id ? { ...item, homeGoal: '-2',awayGoal: '-2' } : item
    //             )
    //         );
    //     }else{
    //         setShowResultList((prev) =>
    //             prev.map((item) =>
    //                 item.eventId === id ? { ...item, homeGoal: 'NE',awayGoal: 'NE' } : item
    //             )
    //         );
    //     }
    // }

    return (
        <div className='w-full max-w-7xl h-full px-2 customFontRoboto'>
            <div className='my-2'>
                <div className='text-sm'>
                    <div className={`flex flex-wrap ${onlyWidth < 480 ? 'gap-2' : 'justify-between'} items-center`}>
                        <div className='flex gap-2'>
                            <div className={`relative flex ${onlyWidth < 480 ? 'w-36 text-xs' : 'w-44 text-sm'} justify-center rounded-sm bg-customTitleColor dark:bg-custom_dark_primary2 mb-1`}>
                                <input
                                    className="bg-customTitleColor dark:bg-custom_dark_primary2 font-semibold text-gray-700 dark:text-customWhite px-5 py-2 rounded-md border border-gray-200 dark:border-custom_dark_primary shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-200 focus:border-gray-100 transition duration-300 ease-in-out w-full cursor-pointer"
                                    type="date"
                                    value={date}
                                    onChange={e => setDate(e.target.value)}
                                />
                                <CustomCalendarSVG />
                            </div>
                            {/* <button
                                className='text-white dark:text-customLightYellow px-5 py-1 my-2 hover:bg-customForeColor rounded-sm bg-slate-900 dark:bg-custom_dark_primary dark:font-semibold dark:border-custom_dark_primary2'
                                onClick={() => handleSearch()}
                            >
                                Search
                            </button> */}
                            <CustomSearchBtn handleSearch={handleSearch} extraStyle={"mt-2"}/>
                        </div>
                        <Badge badgeContent={mixCount} color="error">
                            <span className='text-gray-700 font-semibold text-sm dark:text-customWhite'>Mix Vouchers</span>
                        </Badge>
                        <div className={`flex w-[150px] mx-2 rounded-sm bg-customTitleColor dark:bg-custom_dark_primary2 items-center text-[13px] dark:text-customWhite`}>
                            <div className='main-wrapper relative group'>
                                <div className="flex w-[150px] rounded-sm items-center bg-customTitleColor dark:bg-custom_dark_primary2 cursor-pointer" style={{ paddingTop: 10, paddingBottom: 10 }}>
                                    <span className="flex justify-center items-center w-[90%] bg-customTitleColor dark:bg-custom_dark_primary2 font-semibold">
                                        {selectedFilter?.label}
                                    </span>
                                    <FaAngleDown className="w-8 dark:text-customWhite text-customForeColor" />
                                </div>
                                <ul className='w-full absolute group-hover:block hidden border px-5 py-2 bg-white dark:bg-custom_dark_primary2'>
                                    {
                                        filterType && filterType.map((v, i) => {
                                            return (
                                                <li key={i} className={`p-3 text-center border-b-2 ${i === filterType.length - 1 ? null : 'border-customFontGreen'} text-customFontGreen dark:text-customWhite cursor-pointer`} onClick={() => handleSelect(v)}> {v.label} </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <main className="flex justify-center min-h-[15rem]">
                {
                    isLoading ? <LoadingSpinner />
                        :
                        <table className="border-separate border-spacing-2  w-[100%] ">
                            <thead>
                                <tr>
                                    {
                                        title && title.map((v, i) => {
                                            return (
                                                <th className={`border border-slate-300 dark:border-custom_dark_primary ${onlyWidth < 480 ? 'py-1 text-sm' : 'py-3'} bg-background text-white dark:bg-custom_dark_primary2`} key={i}>{v}</th>
                                            )
                                        })
                                    }
                                    {/* <th className="border border-slate-300 py-3 px-1 w-[10%] bg-background text-white">Action</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    showResultList.length > 0 ? showResultList.map((v, i) => {
                                        return (
                                            <tr key={i}>
                                                <td className="border border-slate-300 dark:border-custom_dark_primary pb-1 dark:bg-custom_dark_primary2">
                                                    <div className='flex justify-between py-2 px-1'>
                                                        <span className={`${onlyWidth < 480 ? 'text-xs' : 'text-sm'} flex items-center gap-1 text-customFontGreen ml-1`}>
                                                            <FaFutbol />
                                                            {v.league}
                                                            {onlyWidth > 480 ?
                                                                <>
                                                                    <Tooltip title="Copy Event" placement="top" arrow>
                                                                        <span onClick={() => handleCopy(v)}>
                                                                            <FaCopy className='cursor-pointer text-customFontGold' size={18} />
                                                                        </span>
                                                                    </Tooltip>
                                                                </>
                                                                : null
                                                            }
                                                        </span>
                                                        {
                                                            onlyWidth < 480 ?
                                                                <div className='flex gap-1'>
                                                                    {/* <FaCopy onClick={() => handleCopy(v)} className='cursor-pointer text-customFontGold' size={18} />
                                                                    <FaFileSignature className='cursor-pointer text-customFontGreen' size={18} /> */}
                                                                </div>
                                                                : 
                                                                <div className='flex gap-3 items-center'>
                                                                    <button className='text-xs px-3 bg-customDarkGreen flex items-center gap-1 text-customWhite rounded-sm py-[2px]' onClick={() => handleCalculateClick(v)}>
                                                                        <FaFileSignature className='cursor-pointer text-customWhite' size={10} />
                                                                        Calculate
                                                                    </button>
                                                                    <span className="text-xs flex items-center gap-1 text-customFontGreen ml-1 italic"><FaClock />{moment(v.event).format("YYYY-MM-DD / hh:mm a")}</span>
                                                                </div>
                                                        }
                                                    </div>
                                                    <div className='flex'>
                                                        <div className={`flex justify-center w-[35%] ${onlyWidth < 480 ? 'text-xs' : 'text-sm'} text-customFontVoilet font-semibold dark:text-customOrange`}>{v.homeTeam}</div>
                                                        <div className="flex justify-center w-[30%]">
                                                            <input type='text'
                                                                className={`text-center ${onlyWidth < 480 ? 'text-sm' : 'text-base'} text-customForeColor dark:text-customWhite
                                                                     outline-none border border-customTitleColor dark:border-custom_dark_primary bg-customTitleColor dark:bg-custom_dark_secondary rounded-sm 
                                                                     w-[30px] md:w-[50px] lg:w-[100px] focus:ring-customRiver
                                                                      dark:focus:ring-customRiver dark:ring-offset-gray-800 focus:ring-1`}
                                                                value={v.homeGoal}
                                                                disabled={selectedFilter.value === "all" || selectedFilter.value === "voucher"}
                                                                onChange={(e) => handleChange(v.eventId, e.target.value, "homeGoal")}
                                                            />
                                                            {/* <span className="relative justify-center text-base text-center rounded text-background mx-3">
                                                                <span className="text-xs font-bold text-red-600 absolute top-[-14px]">{v.voucherCount}</span>
                                                                <FaFileAlt className='cursor-pointer' onClick={() => handleCalculate(v)} />
                                                            </span> */}
                                                            <Badge badgeContent={v.activeVoucherCount} color="error" className='mx-2' anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                                                                <ArticleIcon className='text-sm dark:text-customWhite' />
                                                            </Badge>
                                                            {/* <span className="text-lg font-bold mx-2">-</span> */}
                                                            <input type='text'
                                                                className={`text-center ${onlyWidth < 480 ? 'text-sm' : 'text-base'} text-customForeColor dark:text-customWhite
                                                                    outline-none border border-customTitleColor dark:border-custom_dark_primary bg-customTitleColor dark:bg-custom_dark_secondary rounded-sm 
                                                                    w-[30px] md:w-[50px] lg:w-[100px] focus:ring-customRiver 
                                                                    dark:focus:ring-customRiver dark:ring-offset-gray-800 focus:ring-1`}
                                                                value={v.awayGoal}
                                                                disabled={selectedFilter.value === "all" || selectedFilter.value === "voucher"}
                                                                onChange={(e) => handleChange(v.eventId, e.target.value, "awayGoal")}
                                                            />
                                                        </div>
                                                        <div className={`flex justify-center w-[35%] ${onlyWidth < 480 ? 'text-xs' : 'text-sm'} text-customFontVoilet font-semibold dark:text-customOrange`}>{v.awayTeam}</div>
                                                    </div>
                                                    {onlyWidth > 480 ? null :
                                                        <div className='w-full flex justify-around mt-2'>
                                                            <button className='text-xs px-3 bg-customFontGold flex items-center gap-1 text-customBlack rounded-sm py-[2px]'>
                                                                 <FaCopy onClick={() => handleCopy(v)} className='cursor-pointer text-customBlack' size={10} />
                                                                Copy
                                                            </button>
                                                            <span className="text-xs flex items-center gap-1 text-primary ml-1 italic dark:text-customWhite"><FaClock />{moment(v.event).format("YYYY-MM-DD / hh:mm a")}</span>
                                                            <button className='text-xs px-3 bg-customFontGreen flex items-center gap-1 text-customWhite rounded-sm py-[2px]' onClick={() => handleCalculateClick(v)}>
                                                                <FaFileSignature className='cursor-pointer text-customWhite' size={10} />
                                                                Calculate
                                                            </button>
                                                        </div>
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    }) : 
                                    // <div className='flex justify-center items-center'>
                                    //     <p className='text-customBlack dark:text-customWhite'>No Data Found !</p>
                                    // </div>
                                    <CustomNoData />
                                }
                            </tbody>
                        </table>
                }
            </main>
            {
                selectedFilter.value === "notEnded" && !isLoading ?
                    <div className={`flex justify-center w-[100%] ${onlyWidth < 480 ? 'mb-3' : null}`}>
                        <button className="text-white px-10 py-1 my-2 hover:bg-customAccentBlue/80 dark:hover:bg-customAccent/80 rounded-sm bg-customAccentBlue dark:bg-customAccent dark:border-customAccent/80" onClick={() => handleSave()}>Save</button>
                    </div> : null
            }
            <ConfirmationDialog
                isOpen={!!calculateTarget}
                setIsOpen={() => setCalculateTarget(null)}
                title="Calculate vouchers?"
                contextText={
                    calculateTarget
                        ? `This will calculate pending vouchers for ${calculateTarget.homeTeam} VS ${calculateTarget.awayTeam}.`
                        : ''
                }
                confirmLabel="Calculate"
                cancelLabel="Cancel"
                handleSubmit={handleCalculate}
                isProcessing={isLoading}
                appearance="warning"
            />
        </div>
    )
}

export default InsertResult;

// focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2
